import React from "react";
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
} from "../../../../components/ui/table";
import { useAuth } from "../../../../lib/AuthContext";

interface AuditLogEntry {
  action: string;
  created_at: number;
  id: string;
  object: string;
  target: string;
  user_id: number;
  _user_details: {
    name: string;
    email: string;
    permissions_id: number;
    status: string;
  };
}

interface AuditLogTableProps {
  logs: AuditLogEntry[];
}

const AuditLogTable: React.FC<AuditLogTableProps> = ({ logs }) => {
  const { currentUser } = useAuth();
  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow className="bg-gray-100">
            <TableHead>Action</TableHead>
            <TableHead>Object</TableHead>
            <TableHead>Target</TableHead>
            <TableHead>User Name</TableHead>
            <TableHead>User Email</TableHead>
            <TableHead>Timestamp</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {logs.length > 0 ? (
            logs.map((log) => (
              <TableRow key={log.id}>
                <TableCell>{log.action.toUpperCase()}</TableCell>
                <TableCell>{log.object}</TableCell>
                <TableCell>{currentUser?.user_agency[0].agency_name}</TableCell>
                <TableCell>{log._user_details.name}</TableCell>
                <TableCell>{log._user_details.email}</TableCell>
                <TableCell>
                  {new Date(log.created_at).toLocaleString()}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={6} className="text-center">
                No audit logs available.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default AuditLogTable;
